export class SortData {
    constructor(name, sortName, sortOrder) {
        this.displayName = name;
        this.order = sortOrder;
        this.sortName = sortName;
    }
}
export class SortRecord {
    constructor(list) {
        this.list = list;
    }
}
export class Sorts extends SortRecord {
    constructor(list, name) {
        super(list);
        this.list = list;
        this.name = name;
    }
}
/**
 * @param name is the  main filter key
 * @param filters filterlist
 * @param title for showing in UI
 */
export class Filters {
    constructor(name, filters, title) {
        this.name = name;
        this.filters = filters;
        this.title = title;
    }
}
export class FilterData {
    constructor(simpleFilter, assetFilter, productAssetFilter, underlyingAsset, expiryMonth, instrumentType, optionType, strikePrice) {
        this.simpleFilter = simpleFilter;
        this.assetFilter = assetFilter;
        this.productAssetFilter = productAssetFilter;
        this.underlyingAsset = underlyingAsset;
        this.expiryMonth = expiryMonth;
        this.instrumentType = instrumentType;
        this.optionType = optionType;
        this.strikePrice = strikePrice;
    }
}
